import React from 'react';
import { Badge } from '../../../../ForBrands/ui/BrandUI';
import { usePhoneTheme } from '../../../../ForBrands/useIsPhone';
import { NO_TEAM, teamSettingsRows } from '../coachProfileModel';
import { EmptyCard, KeyValueCard, KeyValueRow, SectionFooter, SectionHead, SupportLink } from '../coachProfilePieces';

// Figma 02 · Team settings: read-only, what the coach picked at onboarding.
// Phones (2471:3981): the description, then the card; long values wrap and
// the team ID sits under its label. No Next (the stack header goes back).
const TeamSettingsSection = ({ team, next, onNext }) => {
  const phone = usePhoneTheme();
  const rows = teamSettingsRows(team);
  return (
    <>
      <SectionHead
        title="Team settings"
        desc={
          <>
            Selected during onboarding. <SupportLink /> to change.
          </>
        }
      />
      {rows.length ? (
        <KeyValueCard>
          {rows.map((row) => (
            <KeyValueRow
              key={row.label}
              label={row.label}
              title={row.value}
              stack={row.stack}
              badge={row.requested ? <Badge tone="passive">Requested</Badge> : null}
            >
              {row.value}
            </KeyValueRow>
          ))}
        </KeyValueCard>
      ) : (
        <EmptyCard>
          {NO_TEAM} <SupportLink /> to add one.
        </EmptyCard>
      )}
      {!phone && <SectionFooter next={next} onNext={onNext} />}
    </>
  );
};

export default TeamSettingsSection;
